export const BaseHierarchy = '__base'
